import { VuexModule, Module, getModule, MutationAction, Mutation, Action } from 'vuex-module-decorators';
import vue from 'vue';
import store from '@/store';
import { Theme } from '../models';

@Module({
    namespaced: true,
    name: 'themes',
    store,
    dynamic: true
})
class ThemesModule extends VuexModule {
    public theme: Theme = {
        name: "Default",
        dataColors: ["#01B8AA","#374649", "#FD625E", "#F2C80F", "#5F6B6D", "#8AD4EB", "#FE9666", "#A66999"],
        background: "#FFFFFF",
        foreground: "#333333",
        tableAccent: "#FFFFFF"
    };

    @Action({ commit: 'addDataColors' })
    public t(x: string) {
        return x;
    }

    @Action({ commit: 'SET_NAME' })
    public setName(x: string) {
        return x;
    }

    @Action({ commit: 'SET_THEME' })
    public setTheme(theme: Theme) {
        return theme;
    }

    @Action({ commit: 'CLEAR_DATA_COLORS' })
    public clearDataColors() {
        return 'Clear Data Colors';
    }

    @Action({ commit: 'REMOVE_DATA_COLORS' })
    public removeDataColor(i: any) {
        return i;
    }


    @Mutation
    private REMOVE_DATA_COLORS(i: any) {
        vue.delete(this.theme.dataColors,i);
    }

    @Action({ commit: 'UPDATE_DATA_COLOR' })
    public updateDataColor(object: any) {
        return object;
    }
    

    @Mutation
    private UPDATE_DATA_COLOR(object: any) {
        vue.set(this.theme.dataColors,object.index,object.color);
    }
    
    @Mutation
    private SET_NAME(x: string) {
        this.theme.name = x;
    }

    @Mutation
    private CLEAR_DATA_COLORS() {
        vue.set(this.theme,"dataColors",[]);
        //this.theme.dataColors = [];
    }

    @Mutation
    private addDataColors(x: string) {
        this.theme.dataColors.push(x);
    }
    
    @Mutation
    private SET_THEME(theme: Theme) {
        this.theme = theme;
        //vue.set(this.theme,0,theme);
    }


    get getTheme() {
        return this.theme;
    }

    get getDataColors() {
        return this.theme.dataColors;
    }

    //@Action({commit: 'setTheme'})

}

export default getModule(ThemesModule);

